export {default} from './widgets.vue'
